import React from "react";

export function FooterAlt() {
    return (
        <div>
            <section className="footer-alt bg-dark pt-3 pb-2">
                <div className="container">
                    <div className="row">
                        <div className="text-center col-lg-12">
                            <p className="copyright text-white f-14 fw-light mb-0">
                                2022 © Manggala-Pustaka. Develop By Kidtz
                            </p>
                        </div>
                    </div>
                </div>
            </section>
        </div>
    );
}

export function FooterList() {
    const linkprod = "https://manggala-pustaka.netlify.app/";
    return (
        <>
            <section className="footer-list">
                <div className="container">
                    <div className="row">
                        <div className="col-lg-4">
                            <div className="mb-5">
                                <p className="text-uppercase text-dark footer-title mb-4">
                                    About Us
                                </p>
                                <p className="text-muted f-14">
                                    Manggala Pustaka website sebuah web yang
                                    menyediakan informasi berupa kegiatan,
                                    artikel, sejarah, struktur organisasi kami
                                </p>
                            </div>
                        </div>
                        <div className="col-lg-8">
                            <div className="row">
                                <div className="col-lg-4">
                                    <div className="mb-5">
                                        <p className="text-uppercase text-dark footer-title mb-4">
                                            Link
                                        </p>
                                        <ul className="list-unstyled footer-sub-menu">
                                            <li className="f-14">
                                                <a
                                                    className="text-muted"
                                                    href={linkprod + "#about"}
                                                >
                                                    About
                                                </a>
                                            </li>
                                            <li className="f-14">
                                                <a
                                                    className="text-muted"
                                                    href={linkprod + "#blog"}
                                                >
                                                    Blog
                                                </a>
                                            </li>
                                            <li className="f-14">
                                                <a
                                                    className="text-muted"
                                                    href={
                                                        linkprod + "#kegiatan"
                                                    }
                                                >
                                                    Kegiatan
                                                </a>
                                            </li>
                                            <li className="f-14">
                                                <a
                                                    className="text-muted"
                                                    href={linkprod + "#gallery"}
                                                >
                                                    Gallery
                                                </a>
                                            </li>
                                        </ul>
                                    </div>
                                </div>
                                <div className="col-lg-4">
                                    <div className="mb-5">
                                        <p className="text-uppercase text-dark footer-title mb-4">
                                            SUPPORT
                                        </p>
                                        <ul className="list-unstyled footer-sub-menu">
                                            <li className="f-14">
                                                <a
                                                    className="text-muted"
                                                    href="#/"
                                                >
                                                    Get Started
                                                </a>
                                            </li>
                                            <li className="f-14">
                                                <a
                                                    className="text-muted"
                                                    href="#/"
                                                >
                                                    Blog
                                                </a>
                                            </li>
                                            <li className="f-14">
                                                <a
                                                    className="text-muted"
                                                    href="#/"
                                                >
                                                    Knowledge Base
                                                </a>
                                            </li>
                                        </ul>
                                    </div>
                                </div>
                                <div className="col-lg-4">
                                    <div className="mb-5">
                                        <p className="text-uppercase text-dark footer-title mb-4">
                                            LEGAL
                                        </p>
                                        <ul className="list-unstyled footer-sub-menu">
                                            <li className="f-14">
                                                <a
                                                    className="text-muted"
                                                    href="#/"
                                                >
                                                    Terms &amp; Conditions
                                                </a>
                                            </li>
                                            <li className="f-14">
                                                <a
                                                    className="text-muted"
                                                    href="#/"
                                                >
                                                    Privacy Policy
                                                </a>
                                            </li>
                                            <li className="f-14">
                                                <a
                                                    className="text-muted"
                                                    href="#/"
                                                >
                                                    Customers
                                                </a>
                                            </li>
                                            <li className="f-14">
                                                <a
                                                    className="text-muted"
                                                    href="#/"
                                                >
                                                    Pricing
                                                </a>
                                            </li>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </>
    );
}
